<!--
  @template IonInputComponent Template

  This template defines an Ionic input field that dynamically binds to a form control.
  - It ensures the input is only rendered when a valid `templateFormGroup` exists.
  - It supports custom placeholder text and error messages.
  - The input type is dynamically determined based on `formField.inputType`, defaulting to 'text'.
  - Label placement is configurable.
  - The input is disabled if `disabledCondition` is true.
-->

<!-- Ensure the input is only rendered if the form group exists -->
<ng-container *ngIf="templateFormGroup"   [formGroup]="templateFormGroup"
class="input-container">

  <!-- Ionic Input Field -->
  <ion-input  
  [id]="formControlName"
  #customInput
    [formControlName]="formControlName"
    [placeholder]="formField.placeholder || 'Enter ' + formField.label.toLowerCase()"
    [type]="formField.inputType? formField.inputType: 'text'"
    [labelPlacement]="labelPlacement"
    [label]="formField.label + (formField.required  && !customInput.value  ? ' *' : '')"
    [disabled]="disabledCondition"
    [errorText]="getErrorText()"
    >  
    
  </ion-input>

</ng-container>



